import angular from 'angular';
import '../../services/user';
import '../../services/errors';

const module = angular.module('whyline.controllers.modals.account', [
  'whyline.services.user',
  'whyline.services.errors',
]);

const AccountModalController = ($scope, $uibModalInstance, UserService, ErrorService, NotificationService, $translate) => {
  'ngInject';

  $scope.me = UserService.CopyCurrent();

  const validate = () => {
    const currentPassword = $scope.me.currentPassword;
    const newPassword = $scope.me.newPassword;
    const confirmPassword = $scope.me.confirmPassword;
    if(!currentPassword) {
      NotificationService.Warning($translate.instant('mandatory_actual_pw'));
      return false;
    }
    if(!newPassword) {
      NotificationService.Warning($translate.instant('mandatory_new_pw'));
      return false;
    }
    if(!confirmPassword) {
      NotificationService.Warning($translate.instant('mandatory_repeat_pw'));
      return false;
    }
    if(newPassword !== confirmPassword) {
      NotificationService.Error($translate.instant('unmatch_new_repeat_pw'), 'Error');
      return false;
    }
    if(newPassword.length < 6 || confirmPassword.length < 6) {
      NotificationService.Error($translate.instant('min_length_new_pw'), 'Error');
      return false;
    }
    return true;
  };

  $scope.save = () => {
    if(validate()) {
      UserService.UpdateCurrent($scope.me)
        .then(() => $scope.cancel())
        .catch(ErrorService.handler);
      // En el then no esta funcionando
      $uibModalInstance.close('cancel');
    }
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };
};

module.exports = module.controller('AccountModalController', AccountModalController);
